import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

export class WmHide extends wmBase {
    constructor(options: widgetOption<boolean>[]) {
        super();
        this.options = options;
    }

    build() {
        const uniqValues = [...new Set(this.options.map((opt) => opt.value))];

        const selected = uniqValues.length === 1 && uniqValues[0] ? "wm_hide_selected" : "";

        this.isHidden = selected !== "";

        return `
            <div class="wm_dividor"></div>
            <div class="wm_hide ${selected}">
                <svg width="21" height="13" viewBox="0 0 21 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" 
                          d="M10.7031 10.8512C7.06194 10.8512 3.86806 8.92332 2.09088 6.02845C3.86806 3.13359 7.06194 1.20569 10.7031 1.20569C14.3443 1.20569 17.5382 3.13359 19.3154 6.02845C17.5382 8.92332 14.3443 10.8512 10.7031 10.8512ZM10.7031 0C15.0412 0 18.8078 2.44273 20.7031 6.02845C18.8078 9.61418 15.04 12.0569 10.7031 12.0569C6.36505 12.0569 2.59847 9.61418 0.703125 6.02845C2.59847 2.44273 6.36505 0 10.7031 0ZM10.7031 9.04268C12.3682 9.04268 13.7174 7.69231 13.7174 6.02845C13.7174 4.3646 12.3682 3.01423 10.7031 3.01423C9.03927 3.01423 7.6889 4.3646 7.6889 6.02845C7.6889 7.69231 9.03927 9.04268 10.7031 9.04268Z" 
                          fill="black" fill-opacity="0.8"/>
                </svg>
            </div>
        `;
    }

    init() {
        const item = document.querySelector<HTMLElement>(".wm_hide");
        item?.removeEventListener("mousedown", this.itemClick, false);
        item?.addEventListener("mousedown", this.itemClick, false);
    }

    itemClick = (e: Event) => {
        const otherSubm = document.querySelector(".widgetSubMenu");
        if (otherSubm) {
            otherSubm.outerHTML = "";
        }

        this.isHidden = !this.isHidden;
        this.applyValue(this.options, this.isHidden);

        const menuItem = document.querySelector<HTMLElement>(".wm_hide");
        if (!menuItem) return;

        menuItem.classList.toggle("wm_hide_selected", this.isHidden);
    };

    name = "wm_hide";
    options: widgetOption<boolean>[] = [];
    isHidden = false;
}
